import { ComponentStyleConfig } from '@chakra-ui/react';

export const Link: ComponentStyleConfig = {
  baseStyle: {
    color: 'M.70',
    textDecoration: 'underline',
    _focus: {
      // TODO: Disable this after making designers agree with focus rings
      boxShadow: 'none',
      textDecoration: 'underline',
    },
    _hover: {
      color: 'M.70',
    },
  },
};
